import { render, staticRenderFns } from "./Archivio.vue?vue&type=template&id=3ccef25c"
import script from "./Archivio.vue?vue&type=script&lang=js"
export * from "./Archivio.vue?vue&type=script&lang=js"
import style0 from "./Archivio.vue?vue&type=style&index=0&id=3ccef25c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports